import React from "react";
import { useI18n } from "@/lib/i18n";
import PrivacyPolicyEn from "@/pages/PrivacyPolicyEn";
import PrivacyPolicyId from "@/pages/PrivacyPolicyId";

export default function PrivacyPolicy() {
  const { lang } = useI18n();
  return lang === "en" ? <PrivacyPolicyEn /> : <PrivacyPolicyId />;
}
